package com.bitterinfant.studio

import androidx.compose.runtime.Composable
import com.bitterinfant.webui.PageShell
import com.bitterinfant.webui.ResponsiveImage
import com.bitterinfant.webui.Site
import com.bitterinfant.webui.YouTubeEmbed
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.renderComposable

fun main() {
    renderComposable(rootElementId = "root") {
        App()
    }
}

@Composable
fun App() {
    PageShell(
        current = Site.STUDIO,
        title = "Bitter Infant Productions",
        tagline = "Voice Over · Animation · Film · Audio",
        titleFontFamily = "'Rye', serif",
    ) {
        Section {
            YouTubeEmbed("HblzghRAM4o")
        }
        Section {
            H2 { Text("What we do") }
            Div(attrs = { style { padding(1.5.cssRem); property("background", "#151518"); property("border-radius", "8px") } }) {
                P(attrs = { style { margin(0.px); fontSize(1.3.cssRem) } }) { Text("Create, Destroy, Rinse and Repeat") }
            }
        }
        Section {
            H2 { Text("The team") }
            P {
                Text("Meet ")
                A(href = "https://laurasteele.bitterinfantproductions.com") { Text("Laura Steele") }
                Text(" — Actor, VO, Producer — and ")
                A(href = "https://matthewthies.bitterinfantproductions.com") { Text("Matthew Thies") }
                Text(" — Coder, Producer, Composer.")
            }
        }
    }
}
